import { UnmatchedDataPointsListDecisionEnum } from "../../apiClient/generated";

// Decisions are stored as upper snake case enums. Map them to nice display
// labels for both the table filter dropdown and the status cell.
//
// These live in their own module so the generic table filters can use them
// without importing the unmatched data table itself.
const DECISION_LABELS: Record<string, string> = {
    [UnmatchedDataPointsListDecisionEnum.Pending]: "Pending",
    [UnmatchedDataPointsListDecisionEnum.NotOwnedByCompany]:
        "Not owned by company",
    [UnmatchedDataPointsListDecisionEnum.OwnedAndLinkToSite]:
        "Link to an existing site",
    [UnmatchedDataPointsListDecisionEnum.OwnedButNoSite]:
        "Site missing from AERSHED",
};

export const DECISION_FILTER_OPTIONS = Object.values(
    UnmatchedDataPointsListDecisionEnum,
).map((value) => ({
    id: value,
    displayValue: DECISION_LABELS[value] ?? value,
}));

export const humanizeDecision = (decision?: string | null) =>
    decision ? (DECISION_LABELS[decision] ?? decision) : undefined;
